import { createGlobalStyle } from "styled-components";
import animation from "./animation";
import variables from "./variables";

const GlobalStyle = createGlobalStyle`
  ${variables};
  ${animation};

  html {
    box-sizing: border-box;
    width: 100%;
    scroll-behavior: smooth;
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  *::-moz-selection { /* Code for Firefox */
    color: var(--selected-text);
    background: var(--selected);
  }

  *::selection {
    color: var(--selected-text);
    background: var(--selected);
  }

  body {
    margin: var(--header-height) 0 0 0;
    background-color: var(--background);
    color: var(--body-color);
    font-family: var(--body-font);
    font-weight: var(--font-normal);

    &.overflow-hide{
      overflow:hidden;
    }
  }
 


  h1,h2,h3,h4,h5,p{
    margin: 0;
  }

  ul,ol{
    margin: 0;
    padding: 0;
    list-style: none;
  }

  a{
    text-decoration: none;
  }

  a:active {
    color: var(--selected-text);
    background-color: var(--selected);
  }

  .active-link {
    color: var(--primary);
  }

  .highlighted-context {
    font-weight:var(--font-semi);
    color :var(--primary);
    cursor:pointer;
    display: inline-block;
    position:relative;

    &::after {
      content: "";
      display: block;
      width: 0;
      height: 2px;
      background: var(--primary);
      transition: width 0.3s;
    }
  
    &:hover::after {
      width: 100%;
    }
  }

  .section {
    padding-top: 48px;
    padding-bottom: 32px;
  }

  .bd-grid{
    display: grid;
    grid-template-columns: 100%;
    grid-column-gap: 64px;
    grid-row-gap: 64px;
    margin-left: var(--mb-4);
    margin-right: var(--mb-4);
  }

  @media screen and (min-width: 1024px){
    .bd-grid{
      margin-left: auto;
      margin-right: auto;
      padding: 0 80px;
    }
  }

  .contained-btn {
    cursor: pointer;
    display: inline-block;
    position: relative;
    border-radius : var(--border-radius);
    padding: 10px 24px;
    color: var(--white);
    background: var(--black-dark);
    outline:none;
    border:none;
    font-family: var(--body-font);
    font-weight: var(--font-semi);
    font-size: var(--small-font-size);
    transition: var(--transition);

    &:hover,
    &:focus,
    &:active { 
      background: var(--gray-dark);
    }

    &:after {
      display: none !important;
    }
  }

  .bounce-animation {
    -moz-animation: bounce 2s infinite;
    -webkit-animation: bounce 2s infinite;
    animation: bounce 2s infinite;
   }

   .anchor {
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      z-index: -1;
      top:var(--anchor-top);
      left: 0;
      visibility: hidden;
   }

   .main_404 {
    min-height: 80vh;
    display: flex;
    justify-content: center;
   }   
}
`;

export default GlobalStyle;
